export default "__VITE_ASSET__6ef3f348__"